var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReviewLogo = function SvgReviewLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M21.784 18.53a8.51 8.51 0 0 0-3.32 0 8.66 8.66 0 0 0 0 3.313 8.51 8.51 0 0 0 3.32 0 8.66 8.66 0 0 0 0-3.312Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M25.288 20.187a8.062 8.062 0 0 0-3.502-1.656 8.035 8.035 0 0 0-1.662-3.498 8.07 8.07 0 0 0-1.657 3.498 8.063 8.063 0 0 0-3.502 1.656 8.064 8.064 0 0 0 3.502 1.656 8.05 8.05 0 0 0 1.657 3.483 8.013 8.013 0 0 0 1.662-3.498 8.062 8.062 0 0 0 3.502-1.656",
    opacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M20.143 25.326a8.087 8.087 0 0 0 7.966 2.803 8.094 8.094 0 0 0-2.197-7.426 12.145 12.145 0 0 0-.61-.55c.209-.17.413-.37.61-.549a8.096 8.096 0 0 0 2.197-7.426 8.106 8.106 0 0 0-7.416 2.194c-.195.21-.379.43-.55.661-.175-.212-.372-.412-.554-.609a8.097 8.097 0 0 0-7.434-2.194 8.09 8.09 0 0 0 2.197 7.426c.197.197.401.371.61.55-.209.17-.413.37-.61.55a8.1 8.1 0 0 0-2.197 7.426 8.094 8.094 0 0 0 7.434-2.195c.197-.21.382-.43.554-.66Z",
    opacity: 0.45
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReviewLogo);
export default ForwardRef;